import { useState, useRef, useEffect } from "react";
import TextFieldGroup from "../../commons/TextFieldGroup";
import Searchbar from "../../commons/Searchbar";
import qs from "qs";

import {
  Layout,
  Breadcrumb,
  Form,
  Table,
  Divider,
  Col,
  Row,
  Collapse,
  PageHeader,
  Button,
} from "antd";

import { formItemLayout, smallFormItemLayout } from "./../../utils/Layouts";
import isEmpty from "../../validation/is-empty";
import { useSelector } from "react-redux";
import {
  edit,
  onDelete,
  onSubmit,
  onSearch,
  onDeleteItem,
  onChange,
  onUpdateStatus,
  hasAccess,
} from "../../utils/form_utilities";
import moment from "moment";
import SelectFieldGroup from "../../commons/SelectFieldGroup";
import {
  onSupplierSearch,
  onStockSearch,
  addKeysToArray,
  onWarehouseSearch,
} from "../../utils/utilities";
import DatePickerFieldGroup from "../../commons/DatePickerFieldGroup";
import TextAreaGroup from "../../commons/TextAreaGroup";
import numberFormat from "../../utils/numberFormat";
import round from "../../utils/round";
import { sumBy } from "lodash";
import WarehouseFormModal from "../modals/WarehouseFormModal";
import { useNavigate, useParams } from "react-router-dom";
import FormButtons from "../../commons/FormButtons";
import classNames from "classnames";
import {
  ACCESS_ADD,
  ACCESS_ADVANCE_SEARCH,
  ACCESS_OPEN,
  ACCESS_VIEW,
  CANCELLED,
  OPEN,
  PERMISSION_PROJECTED_DISPLAY,
  STATUS_CLOSED,
} from "../../utils/constants";
import RangeDatePickerFieldGroup from "../../commons/RangeDatePickerFieldGroup";
import SimpleSelectFieldGroup from "../../commons/SimpleSelectFieldGroup";
import AccountFormModal from "../modals/AccountFormModal";
import StockFormModal from "../modals/StockFormModal";
import computeItemDetails from "../../utils/computeItemDetails";

const { Content } = Layout;
const { Panel } = Collapse;

const transaction = "production";
const url = `/api/${transaction}/`;
const title = "Production Form";

const initialItemValues = {
  stock: "",
  quantity: "",
  price: "",
  amount: "",
  supplier: "",
  notes: "",
  estimate_quantity: 0,
  total_withdrawn_quantity: 0,
  inventory_quantity: 0,
};

const transaction_counter = {
  label: "PROD #",
  key: "doc_no",
};

const date_fields = ["date", "deadline"];

export default function ProductionForm({}) {
  const params = useParams();
  const [errors, setErrors] = useState({});
  const [loading_state, setLoadingState] = useState({});
  const [records, setRecords] = useState([]);
  const [processing, setProcessing] = useState(false);
  const [total_records, setTotalRecords] = useState(null);
  const [current_page, setCurrentPage] = useState(1);
  const [search_keyword, setSearchKeyword] = useState("");
  const auth = useSelector((state) => state.auth);
  const [item, setItem] = useState(initialItemValues);
  const [dr_numbers, setDrNumbers] = useState([]);
  const [options, setOptions] = useState({
    suppliers: [],
    stocks: [],
    purchase_orders: [],
    warehouses: [],
  });
  const [page_size, setPageSize] = useState(100);
  const [formulation, setFormulation] = useState({});

  const [loading, setLoading] = useState(false);
  const accountFormModal = useRef(null);
  const stockFormModal = useRef(null);
  const warehouseFormModal = useRef(null);
  const caseQuantityField = useRef(null);
  const quanttiyField = useRef(null);
  const casePriceField = useRef(null);
  const priceField = useRef(null);
  const amountField = useRef(null);
  const addItemButton = useRef(null);
  const stockField = useRef(null);

  const navigate = useNavigate();
  const [search_state, setSearchState] = useState({});

  const initialValues = {
    _id: null,
    rr_no: null,
    date: moment(),
    supplier: null,
    warehouse: auth.user?.warehouse,
    remarks: "",
    items: [
      {
        ...initialItemValues,
      },
    ],
    discounts: [],

    purchase_order: null,
    stock_release: null,
    sales_return: null,
    customer: null,

    gross_amount: 0,
    total_discount_amount: 0,
    total_amount: 0,
  };
  const [state, setState] = useState(initialValues);

  const records_column = [
    {
      title: "Prod #",
      dataIndex: "doc_no",
    },
    {
      title: "Date",
      dataIndex: "date",
      render: (date) => moment(date).format("MM/DD/YYYY"),
    },
    {
      title: "Warehouse",
      dataIndex: ["warehouse", "name"],
    },
    {
      title: "Finished Product",
      dataIndex: ["finished_product", "name"],
    },
    {
      title: "Quantity",
      width: 100,
      align: "right",
      dataIndex: ["produced_quantity"],
    },

    {
      title: "Unit",
      align: "center",
      width: 100,
      dataIndex: ["finished_product", "unit_of_measure"],
    },
    {
      title: "Items",
      dataIndex: "items",
      width: 350,
      render: (items) =>
        (items || [])
          .slice(0, 4)
          .map(
            (o) =>
              `${o.quantity} ${o.stock?.unit_of_measure} x ${o?.stock?.name}`
          )
          .join("/ "),
    },

    {
      title: "Status",
      dataIndex: ["status"],
      align: "center",
      render: (status, record, index) => {
        return (
          <span
            className={classNames("has-text-weight-bold", {
              "has-text-danger": status?.approval_status === CANCELLED,
            })}
          >
            {status?.approval_status || ""}
          </span>
        );
      },
    },
  ];

  const items_column = [
    {
      title: (
        <div>
          <span>Items &emsp;</span>
          <span className="has-text-weight-bold">
            <span
              className="legend-color"
              style={{ backgroundColor: "#f8d7da" }}
            ></span>
            Main Ingredient
          </span>
        </div>
      ),
      dataIndex: ["stock"],
      render: (stock, record, record_index) => {
        return (
          record.footer !== 1 && (
            <SelectFieldGroup
              value={stock?.name}
              disabled={!state.finished_product?._id}
              onSearch={(value) =>
                onStockSearch({ value, options, setOptions })
              }
              onChange={(index) => {
                const stock = options.stocks?.[index] || null;

                if (stock) {
                  setState((prevState) => {
                    const items = [...(prevState.items || [])];

                    items[record_index].stock = stock;

                    if (items.length - 1 === record_index) {
                      items.push({
                        ...initialItemValues,
                        category: items[record_index].category,
                      });
                    }

                    return {
                      ...prevState,
                      items,
                    };
                  });
                }
              }}
              error={errors.stock?.name}
              formItemLayout={null}
              data={options.stocks}
              column="display_name"
              onAddItem={() => stockFormModal.current.open(record_index)}
            />
          )
        );
      },
    },

    {
      title: "Qty",
      dataIndex: "quantity",
      align: "right",
      width: 200,
      render: (value, record, index) => (
        <span>
          {record.footer !== 1 &&
          [undefined, OPEN].includes(state.status?.approval_status) ? (
            <Row gutter={8}>
              <Col span={24}>
                <input
                  type="number"
                  step={0.01}
                  className="has-text-right input-value"
                  value={record.quantity}
                  disabled={!state.finished_product?._id}
                  onChange={(e) => {
                    const value = e.target.value;
                    setState((prevState) => {
                      let items = [...state.items];

                      items[index] = {
                        ...items[index],
                        ...computeItemDetails({
                          ...items[index],
                          quantity: value,
                        }),
                      };

                      if (items.length - 1 === index) {
                        items.push({
                          ...initialItemValues,
                          category: items[index].category,
                        });
                      }

                      const sum_quantity =
                        sumBy(items, (o) => parseFloat(o.quantity) || 0) || 0;
                      const formulation_sum =
                        sumBy(
                          state?.formulation_product?.items,
                          (o) => parseFloat(o.quantity) || 0
                        ) || 0;

                      const projected_quantity =
                        Math.floor(
                          parseFloat(sum_quantity) / parseFloat(formulation_sum)
                        ) || 0;

                      const variance =
                        (prevState.produced_quantity || 0) - projected_quantity;

                      console.log(sum_quantity, formulation_sum);

                      return {
                        ...prevState,
                        projected_quantity,
                        variance,
                        items,
                      };
                    });
                  }}
                  align="right"
                />
              </Col>
            </Row>
          ) : (
            `${numberFormat(record.quantity)}`
          )}
        </span>
      ),
    },
    {
      title: "Unit",
      dataIndex: ["stock", "unit_of_measure"],
      align: "center",
      width: 100,
    },

    {
      title: "",
      key: "action",
      width: 80,
      align: "center",
      render: (text, record, index) => (
        <span>
          {record.footer !== 1 &&
            [undefined, OPEN].includes(state.status?.approval_status) && (
              <span
                onClick={() =>
                  onDeleteItem({
                    field: "items",
                    index,
                    setState,
                  })
                }
              >
                <i className="fas fa-trash-alt"></i>
              </span>
            )}
        </span>
      ),
    },
  ];

  const can_edit =
    isEmpty(state.status) || [OPEN].includes(state.status?.approval_status);

  const handleDelete = () => {
    onDelete({
      id: state._id,
      url,
      user: auth.user,
      cb: () => {
        onSearch({
          page: current_page,
          page_size,
          search_keyword,
          url,
          setRecords,
          setTotalRecords,
          setCurrentPage,
          setErrors,
          advance_search: { ...search_state },
        });
      },
    });
  };

  const handleSearch = () => {
    console.log("handleSearch >> ", "Ok");
    debugger;
    onSearch({
      page: current_page,
      page_size,
      search_keyword,
      url,
      setRecords,
      setTotalRecords,
      setCurrentPage,
      setErrors,
      advance_search: { ...search_state },
    });
  };

  const handleClose = () => {
    onUpdateStatus({
      url,
      state,
      approval_status: STATUS_CLOSED,
      user: auth.user,
      cb: () => {
        edit({
          record: state,
          setState,
          setErrors,
          setRecords,
          url,
          date_fields,
        });
      },
    });
  };

  const handleFinish = () => {
    onSubmit({
      values: {
        ...state,
        items: state.items.filter((o) => !isEmpty(o.stock?._id)),
      },
      auth,
      url,
      setErrors,
      setState,
      date_fields,
      setLoading,
    });
  };

  //ON CHANGE FORMULATION PRODUCT
  // useEffect(() => {
  //   setState((prevState) => {
  //     const index = 0;

  //     let items = [...(prevState.formulation_product?.items || [])];

  //     // console.log(state.formulation_product);

  //     items = items.map((item) => ({
  //       ...item,
  //       quantity: "",
  //     }));

  //     items.push({
  //       ...initialItemValues,
  //     });
  //     return {
  //       ...prevState,
  //       items,
  //     };
  //   });

  //   return () => {};
  // }, [state.formulation_product]);

  useEffect(() => {
    const query = qs.parse(location.search, { ignoreQueryPrefix: true });

    const { _id } = query;

    (async () => {
      if (_id) {
        return edit({
          record: {
            _id,
          },
          setState,
          setErrors,
          setRecords,
          url,
          date_fields,
        });
      }
    })();

    return () => {};
  }, []);

  useEffect(() => {
    if (params?.id) {
      edit({
        record: {
          _id: params.id,
        },
        setState,
        setErrors,
        setRecords,
        url,
        date_fields,
      });
    }
    return () => {};
  }, []);

  return (
    <Content className="content-padding">
      <StockFormModal
        setField={(stock, index) => {
          setState((prevState) => {
            const items = [...prevState.items];
            items[index].stock = stock;

            if (items.length - 1 === index) {
              items.push({
                ...initialItemValues,
              });
            }

            return {
              ...prevState,
              items,
            };
          });
        }}
        ref={stockFormModal}
      />
      <WarehouseFormModal
        setField={(warehouse) => {
          setState((prevState) => ({
            ...prevState,
            warehouse,
          }));
        }}
        ref={warehouseFormModal}
      />
      <AccountFormModal
        setField={(account) => {
          setState((prevState) => ({
            ...prevState,
            account,
          }));
        }}
        ref={accountFormModal}
      />
      <div className="columns is-marginless">
        <div className="column">
          <Breadcrumb style={{ margin: "16px 0" }}>
            <Breadcrumb.Item>Home</Breadcrumb.Item>
            <Breadcrumb.Item className="text-color-yellow">
              {title}
            </Breadcrumb.Item>
          </Breadcrumb>
        </div>
        <div className="column">
          <Searchbar
            name="search_keyword"
            onChange={(e) => setSearchKeyword(e.target.value)}
            value={search_keyword}
            onNew={
              hasAccess({
                auth,
                access: ACCESS_ADD,
                location,
              })
                ? () => {
                    setState({
                      ...initialValues,
                      date: moment(),
                      branch: auth.user?.branches?.[0] || null,
                      items: [
                        {
                          ...initialItemValues,
                        },
                      ],
                    });
                    setItem(initialItemValues);
                    setRecords([]);
                  }
                : null
            }
          />
        </div>
      </div>

      {hasAccess({
        auth,
        access: ACCESS_ADVANCE_SEARCH,
        location,
      }) && (
        <Row>
          <Col span={24} className="m-b-1">
            <Collapse>
              <Panel header="Advance Search" key="1">
                <PageHeader
                  backIcon={false}
                  style={{
                    border: "1px solid rgb(235, 237, 240)",
                  }}
                  onBack={() => null}
                  title="Advance Filter"
                  subTitle="Enter appropriate data to filter records"
                >
                  <div className="or-slip-form">
                    <Row>
                      <Col span={8}>
                        <RangeDatePickerFieldGroup
                          label="Date"
                          name="period_covered"
                          value={search_state.period_covered}
                          onChange={(dates) =>
                            setSearchState((prevState) => ({
                              ...prevState,
                              period_covered: dates,
                            }))
                          }
                          formItemLayout={smallFormItemLayout}
                        />
                      </Col>
                      <Col span={8}>
                        <SimpleSelectFieldGroup
                          label="Status"
                          name="approval_status"
                          value={search_state.approval_status}
                          onChange={(value) => {
                            onChange({
                              key: "approval_status",
                              value: value,
                              setState: setSearchState,
                            });
                          }}
                          error={errors?.approval_status}
                          formItemLayout={smallFormItemLayout}
                          options={[OPEN, STATUS_CLOSED, CANCELLED] || []}
                        />
                      </Col>
                      <Col span={8}>
                        <SelectFieldGroup
                          label="Item"
                          value={search_state.stock?.name}
                          onSearch={(value) =>
                            onStockSearch({ value, options, setOptions })
                          }
                          onChange={(index) => {
                            const stock = options.stocks[index];
                            setSearchState((prevState) => ({
                              ...prevState,
                              stock,
                            }));
                          }}
                          formItemLayout={smallFormItemLayout}
                          data={options.stocks}
                          column="display_name"
                        />
                      </Col>
                    </Row>
                    <Row>
                      <Col span={8}>
                        <SelectFieldGroup
                          label="Account"
                          value={search_state.account?.name}
                          onFocus={() => {
                            onSupplierSearch({ value: "", setOptions });
                          }}
                          onSearch={(value) =>
                            onSupplierSearch({ value, setOptions })
                          }
                          onChange={(index) => {
                            const account = options.accounts?.[index] || null;
                            setSearchState((prevState) => ({
                              ...prevState,
                              account,
                            }));
                          }}
                          formItemLayout={smallFormItemLayout}
                          data={options.accounts}
                          column="name"
                        />
                      </Col>
                      <Col span={8}>
                        <SelectFieldGroup
                          label="Warehouse"
                          value={search_state.warehouse?.name}
                          onFocus={() => {
                            onWarehouseSearch({ value: "", setOptions });
                          }}
                          onSearch={(value) =>
                            onWarehouseSearch({ value, setOptions })
                          }
                          onChange={(index) => {
                            const warehouse =
                              options.warehouses?.[index] || null;
                            onChange({
                              key: "warehouse",
                              value: warehouse,
                              setState: setSearchState,
                            });
                          }}
                          formItemLayout={smallFormItemLayout}
                          data={options.warehouses}
                          column="name"
                          error={errors.warehouse}
                        />
                      </Col>
                    </Row>

                    <Row>
                      <Col span={8}>
                        <Row>
                          <Col offset={8} span={12}>
                            <Button
                              type="info"
                              size="large"
                              icon={
                                <i className="fa-solid fa-magnifying-glass pad-right-8"></i>
                              }
                              onClick={() => {
                                onSearch({
                                  page: 1,
                                  page_size,
                                  search_keyword,
                                  url,
                                  setRecords,
                                  setTotalRecords,
                                  setCurrentPage,
                                  setErrors,
                                  advance_search: { ...search_state },
                                });
                              }}
                            >
                              Search
                            </Button>
                          </Col>
                        </Row>
                      </Col>
                      <Col span={8}></Col>
                      <Col span={8}></Col>
                    </Row>
                  </div>
                </PageHeader>
              </Panel>
            </Collapse>
          </Col>
        </Row>
      )}

      <div
        style={{
          background: "#fff",
          padding: 24,
          borderBottomLeftRadius: 10,
          borderBottomRightRadius: 10,
        }}
      >
        <Row>
          <Col span={12}>
            <span className="module-title">{title}</span>
          </Col>
        </Row>

        <Divider />
        {isEmpty(records) ? (
          <Form onFinish={handleFinish} initialValues={initialValues}>
            {state[transaction_counter.key] && (
              <Row>
                <Col span={12}>
                  <TextFieldGroup
                    label={transaction_counter.label}
                    value={state[transaction_counter.key]}
                    error={errors.remarks}
                    formItemLayout={smallFormItemLayout}
                    readOnly
                  />
                </Col>
              </Row>
            )}

            <Row>
              <Col span={12}>
                <DatePickerFieldGroup
                  label="Date"
                  name="date"
                  value={state.date || null}
                  onChange={(value) => {
                    onChange({
                      key: "date",
                      value: value,
                      setState,
                    });
                  }}
                  error={errors.date}
                  formItemLayout={smallFormItemLayout}
                />
              </Col>
            </Row>
            <Row>
              <Col span={12}>
                <SelectFieldGroup
                  label="Finished Product"
                  value={state.finished_product?.name}
                  onFocus={() => {
                    onStockSearch({ value: "", setOptions });
                  }}
                  onSearch={(value) => onStockSearch({ value, setOptions })}
                  onChange={(index) => {
                    const finished_product = options.stocks?.[index] || null;
                    const formulation_product = finished_product?.formulation;

                    let items = [...(formulation_product?.items || [])];
                    items = items.map((item) => ({
                      ...item,
                      quantity: "",
                    }));

                    items.push({
                      ...initialItemValues,
                    });

                    setState((prevState) => ({
                      ...prevState,
                      formulation_product: formulation_product
                        ? formulation_product
                        : "",
                      finished_product,
                      items,
                    }));
                  }}
                  formItemLayout={smallFormItemLayout}
                  data={options.stocks}
                  column="name"
                  error={errors.finished_product}
                  help={
                    !state.finished_product?._id
                      ? "Finished Product is Required"
                      : ""
                  }
                />
              </Col>
              <Col span={12}>
                <SelectFieldGroup
                  label="Warehouse"
                  value={state.warehouse?.name}
                  onFocus={() => {
                    onWarehouseSearch({ value: "", setOptions });
                  }}
                  onSearch={(value) => onWarehouseSearch({ value, setOptions })}
                  onChange={(index) => {
                    const warehouse = options.warehouses?.[index] || null;
                    onChange({
                      key: "warehouse",
                      value: warehouse,
                      setState,
                    });
                  }}
                  formItemLayout={smallFormItemLayout}
                  data={options.warehouses}
                  column="name"
                  error={errors.warehouse}
                />
              </Col>
            </Row>
            <Row>
              <Col span={12}>
                <TextFieldGroup
                  label="Produced Quantity"
                  type="number"
                  step={0.01}
                  name="produced_quantity"
                  value={state.produced_quantity}
                  error={errors.produced_quantity}
                  onChange={(e) => {
                    const value = e.target.value;
                    onChange({
                      key: e.target.name,
                      value: value,
                      setState,
                    });

                    onChange({
                      key: "variance",
                      value: value - state.projected_quantity,
                      setState,
                    });
                  }}
                  formItemLayout={smallFormItemLayout}
                />
              </Col>
              <Col span={12}>
                {hasAccess({
                  auth,
                  access: ACCESS_VIEW,
                  location: {
                    pathname: PERMISSION_PROJECTED_DISPLAY,
                  },
                }) && (
                  <TextFieldGroup
                    label="Projected Quantity"
                    type="number"
                    step={0.01}
                    name="projected_quantity"
                    readOnly
                    value={state.projected_quantity}
                    error={errors.projected_quantity}
                    formItemLayout={smallFormItemLayout}
                  />
                )}
              </Col>
            </Row>

            <Row>
              <Col span={12}>
                <TextFieldGroup
                  label="Unit"
                  readOnly
                  value={state.finished_product?.unit_of_measure}
                  formItemLayout={smallFormItemLayout}
                />
              </Col>
              <Col span={12}>
                {hasAccess({
                  auth,
                  access: ACCESS_VIEW,
                  location: {
                    pathname: PERMISSION_PROJECTED_DISPLAY,
                  },
                }) && (
                  <TextFieldGroup
                    label="Variance"
                    type="number"
                    step={0.01}
                    value={state.variance}
                    readOnly
                    formItemLayout={smallFormItemLayout}
                  />
                )}
              </Col>
            </Row>

            <TextAreaGroup
              label="Remarks"
              name="remarks"
              value={state.remarks}
              error={errors.remarks}
              onChange={(e) => {
                onChange({
                  key: e.target.name,
                  value: e.target.value,
                  setState,
                });
              }}
              formItemLayout={formItemLayout}
            />
            {state.status && state.status.datetime && (
              <TextFieldGroup
                label="Status"
                name="status"
                value={`${state.status.approval_status} / ${
                  state.status.user.name
                } / ${moment(state.status.datetime).format("LLL")}`}
                formItemLayout={formItemLayout}
                readOnly
              />
            )}
            {state.deleted && state.deleted.date && (
              <TextFieldGroup
                label="Voided By"
                name="status"
                value={`${state.deleted?.user?.name} / ${moment(
                  state.deleted.date
                ).format("LLL")}`}
                formItemLayout={formItemLayout}
                readOnly
              />
            )}
            <Table
              dataSource={addKeysToArray([
                ...state.items,
                {
                  footer: 1,
                  quantity: sumBy(state.items, (o) => round(o.quantity)),
                  case_quantity: sumBy(state.items, (o) =>
                    round(o.case_quantity)
                  ),
                  amount: sumBy(state.items, (o) => round(o.amount)),
                },
              ])}
              columns={items_column}
              pagination={false}
              rowClassName={(record, index) => {
                // if (index === 0) {
                //   return "important-ingredient-row has-text-weight-bold";
                // }
                if (record.footer === 1) {
                  return "footer-summary has-text-weight-bold";
                }
              }}
            />

            <FormButtons
              state={state}
              auth={auth}
              loading={loading}
              loading_state={loading_state}
              url={url}
              initialValues={initialValues}
              initialItemValues={initialItemValues}
              setState={setState}
              setItem={setItem}
              onDelete={handleDelete}
              onSearch={handleSearch}
              onClose={handleClose}
              has_print={!isEmpty(state._id)}
              has_cancel={!isEmpty(state._id)}
              onPrint={() =>
                window.open(`/print/${transaction}/${state._id}`, "_tab")
              }
              has_save={can_edit}
            />
          </Form>
        ) : (
          <Table
            dataSource={addKeysToArray(records)}
            columns={records_column}
            rowKey={(record) => record._id}
            onRow={(record, index) => {
              return {
                onDoubleClick: (e) => {
                  if (
                    hasAccess({
                      auth,
                      access: ACCESS_OPEN,
                      location,
                    })
                  ) {
                    edit({
                      record,
                      setState: (record) => {
                        setState({
                          ...record,
                          items: [
                            ...record.items,
                            {
                              ...initialItemValues,
                            },
                          ],
                        });
                      },
                      setErrors,
                      setRecords,
                      url,
                      date_fields,
                    });
                  }
                },
              };
            }}
            pagination={{
              current: current_page,
              defaultCurrent: current_page,
              onChange: (page, page_size) => {
                setPageSize(page_size);
                onSearch({
                  page,
                  page_size,
                  search_keyword,
                  url,
                  setRecords,
                  setTotalRecords,
                  setCurrentPage,
                  setErrors,
                  advance_search: { ...search_state },
                });
              },
              total: total_records,
              pageSize: page_size,
            }}
          />
        )}
      </div>
    </Content>
  );
}
